import Request from "./request";
const area = "/areas";

export default {
  async getArea() {
    return Request.getArea(area);
  }
};
